import { useMsal } from "@azure/msal-react";
import { useCallback } from "react";
import { FETCH_AD_USERS } from "../store/services/endpoints/user";

const useADUsers = () => {
  const { instance, accounts } = useMsal();

  const acquireGraphToken = useCallback(async () => {
    if (accounts.length === 0) return null;
    try {
      const response = await instance.acquireTokenSilent({
        scopes: ["User.ReadBasic.All"],
        account: accounts[0],
      });
      return response.accessToken;
    } catch (error) {
      console.error("Failed to acquire Graph token:", error);
      return null;
    }
  }, [instance, accounts]);

  const searchUsers = useCallback(async (searchQuery, accessToken) => {
    try {
      const filterQuery = encodeURIComponent(
        `startswith(displayName,'${searchQuery}') or startswith(mail,'${searchQuery}') or startswith(givenName,'${searchQuery}') or startswith(surname,'${searchQuery}')`
      );

      const response = await fetch(`${FETCH_AD_USERS}?$filter=${filterQuery}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Error fetching users: ${response.statusText}`);
      }

      const data = await response.json();
      return data.value;
    } catch (error) {
      console.error("Error in searchUsers:", error);
      return [];
    }
  }, []);

  const getADUsers = useCallback(
    async (inputValue) => {
      try {
        const accessToken = await acquireGraphToken();
        if (!accessToken) {
          return [];
        }

        const users = await searchUsers(inputValue, accessToken);

        return users.map((user) => ({
          id: user.id,
          displayName: user.displayName,
          emailId: user.mail,
          firstName: user.givenName || "",
          lastName: user.surname || "",
        }));
      } catch (error) {
        console.error("Error fetching AD users:", error);
        return [];
      }
    },
    [acquireGraphToken, searchUsers]
  );

  return { getADUsers };
};

export default useADUsers;
